import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProgrammingSm = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Layer_1",
		"data-name": "Layer 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				className: "icon-white",
				d: "M66.83,71.92h-.66a2.69,2.69,0,0,1-2.62-2.7V66.91a3.3,3.3,0,0,1,.17-.94l.12-.34h-.91a.68.68,0,0,1-.68-.45l-2.47-7.6H50.89a2.22,2.22,0,0,1-2.16-2.16v-30H44.19V20.22h4.54V15.14A2.22,2.22,0,0,1,50.88,13h36a2.22,2.22,0,0,1,2.16,2.16v5.08h4.55v5.23H89.06V55.5a2.21,2.21,0,0,1-2.15,2.16H78l-2.46,7.56a.85.85,0,0,1-.69.49h-1L74,66a1.17,1.17,0,0,0,0,.2,2.87,2.87,0,0,1,.12.76V69.3a2.61,2.61,0,0,1-2.61,2.62H66.83Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M41.72,23.05a1.22,1.22,0,0,0-.17-.55,1.1,1.1,0,0,0-.25-.31l-2.46-3.64a1.65,1.65,0,0,0-2-.49,1.34,1.34,0,0,0-.79.84A1.32,1.32,0,0,0,36.18,20l1.14,1.7H32.46V18.6a5.94,5.94,0,0,0-11.88,0v9.2a5.94,5.94,0,0,0,11.88,0V24.66h4.86l-1.15,1.7A1.35,1.35,0,0,0,36,27.5a1.31,1.31,0,0,0,.74.83,1.69,1.69,0,0,0,2.1-.5l2.4-3.57.11-.1a1,1,0,0,0,.2-.29l.07-.14a1.06,1.06,0,0,0,.08-.33l0-.12ZM29.41,18.6v9.2a2.89,2.89,0,0,1-5.78,0V18.6a2.89,2.89,0,0,1,5.78,0Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M9.59,66.73a1.52,1.52,0,0,0-1.52,1.52v18a1.53,1.53,0,1,0,3,0v-18A1.53,1.53,0,0,0,9.59,66.73Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M26.52,66.73a6,6,0,0,0-5.94,5.94v9.2a5.94,5.94,0,0,0,11.88,0v-9.2A6,6,0,0,0,26.52,66.73Zm2.89,5.94v9.2a2.89,2.89,0,0,1-5.78,0v-9.2a2.89,2.89,0,1,1,5.78,0Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M29.26,60.77a1.52,1.52,0,0,0,1.52-1.52v-18a1.53,1.53,0,1,0-3.05,0v18A1.53,1.53,0,0,0,29.26,60.77Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M12.33,39.69a6,6,0,0,0-5.94,5.94v9.2a5.94,5.94,0,1,0,11.88,0v-9.2A6,6,0,0,0,12.33,39.69Zm2.89,5.94v9.2a2.89,2.89,0,0,1-5.78,0v-9.2a2.89,2.89,0,0,1,5.78,0Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M9.59,33.74a1.53,1.53,0,0,0,1.53-1.53v-18a1.53,1.53,0,1,0-3,0v18A1.52,1.52,0,0,0,9.59,33.74Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M93.61,22.44V19.55H90.18V15.14a3,3,0,0,0-3-3H50.57a3,3,0,0,0-3,3v4.41H44.19v2.91h6.5V15.31a.16.16,0,0,1,.16-.16H87.13a.17.17,0,0,1,.16.16V55.94a.16.16,0,0,1-.16.16h-8V46.89a10.21,10.21,0,0,0-20.42,0v9.3H50.85a.16.16,0,0,1-.16-.16V23.52h-6.5V26.4h3.43V56.13a3,3,0,0,0,3,3h8.49l2.33,7.17a1.46,1.46,0,0,0,1.35,1,4.55,4.55,0,0,0,0,.53v2.36A3.52,3.52,0,0,0,66,73.69V85a2.86,2.86,0,1,0,5.71,0V73.69A3.44,3.44,0,0,0,75,70.26V67.91a2.87,2.87,0,0,0-.06-.54h0a1.62,1.62,0,0,0,1.41-1l2.34-7.19h8.5a3,3,0,0,0,3-3V26.39h3.43v-3H90.18v-1ZM72.12,67.81v2.36a.55.55,0,0,1-.54.54H66.12a.54.54,0,0,1-.54-.54V67.81a.54.54,0,0,1,.54-.53h5.46A.54.54,0,0,1,72.12,67.81ZM76.07,47V57.65L74,64.39h-10l-2.31-7.12V47a7.23,7.23,0,1,1,14.45,0Z"
			})
		]
	})
});
export default SvgProgrammingSm;
